export default __webpack_public_path__ + "static/media/pic9.10eca8d3.jpg";